import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withErrorGuard from "../../../../../../HOC/withErrorGuard";
import Gnomad from "../Gnomad";
import {
  getGenome,
  getVariantResult,
} from "../../../../../../state/selectors/general.selectors";

const GnomadMito = ({ variantResult, genome }) => {
  return (
    <Gnomad
      gnomadType="mito"
      variantResult={variantResult}
      genome={genome}
      isMito={true}
    />
  );
};

GnomadMito.propTypes = {
  variantResult: PropTypes.shape({
    gnomad_genomes: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
      })
    ),
  }),
  genome: PropTypes.shape({
    name: PropTypes.string,
  }),
};

GnomadMito.defaultProps = {
  variantResult: {},
  genome: {},
};

const mapStateToProps = (state) => {
  return {
    variantResult: getVariantResult(state),
    genome: getGenome(state),
  };
};

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(GnomadMito, "gnomadMito", "gnomAD Mito"));
